type OpenPanelWithMessageFn = (message?: string) => void;
type RegistrationListener = (isRegistered: boolean) => void;

let registeredCallback: OpenPanelWithMessageFn | null = null;
const listeners = new Set<RegistrationListener>();

export const onboardingAgentExternalService = {
    register: (fn: OpenPanelWithMessageFn): void => {
        registeredCallback = fn;
        listeners.forEach((l) => l(true));
    },
    unregister: (): void => {
        registeredCallback = null;
        listeners.forEach((l) => l(false));
    },
    openWithMessage: (message?: string): void => {
        registeredCallback?.(message);
    },
    isRegistered: (): boolean => registeredCallback !== null,
    subscribe: (listener: RegistrationListener): (() => void) => {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },
};
